<div class="md-editor-container" [class.font-awesome5]="options?.usingFontAwesome5" [class.fullscreen]="isFullScreen"
  [class.md-editor-resizable]="options?.resizable" [style.height]="height">
  <div class="md-layout">
    <div class="tool-bar" *ngIf="!hideToolbar && mode != 'preview'">
      <div class="btn-group">
        <button class="btn btn-sm btn-default" type="button" title="Bold" (click)="insertContent('Bold')"
          *ngIf="!hideIcons.Bold">
          <i class="fa fa-bold"></i>
        </button>
        <button class="btn btn-sm btn-default" type="button" title="Italic" (click)="insertContent('Italic')"
          *ngIf="!hideIcons.Italic">
          <i class="fa fa-italic"></i>
        </button>
        <button class="btn btn-sm btn-default" type="button" title="Heading" (click)="insertContent('Heading')"
          *ngIf="!hideIcons.Heading">
          <i class="fa fa-header"></i>
        </button>
        <button class="btn btn-sm btn-default" type="button" title="Reference" (click)="insertContent('Reference')"
          *ngIf="!hideIcons.Reference">
          <i class="fa fa-quote-left"></i>
        </button>
      </div>
      <div class="btn-group">
        <button class="btn btn-sm btn-default" type="button" title="Link" (click)="insertContent('Link')"
          *ngIf="!hideIcons.Link">
          <i class="fa fa-link"></i>
        </button>
        <button class="btn btn-sm btn-default" type="button" title="Image" (click)="insertContent('Image')"
          *ngIf="!hideIcons.Image">
          <i class="fa fa-image"></i>
        </button>
      </div>
      <div class="btn-group">
        <button class="btn btn-sm btn-default" type="button" title="Unordered List" (click)="insertContent('Ul')"
          *ngIf="!hideIcons.Ul">
          <i class="fa fa-list-ul"></i>
        </button>
        <button class="btn btn-sm btn-default" type="button" title="Ordered List" (click)="insertContent('Ol')"
          *ngIf="!hideIcons.Ol">
          <i class="fa fa-list-ol"></i>
        </button>
        <button class="btn btn-sm btn-default" type="button" title="Code Block" (click)="insertContent('Code')"
          *ngIf="!hideIcons.Code">
          <i class="fa fa-file-code-o"></i>
        </button>
      </div>
      <div class="btn-group">
        <button class="btn btn-sm btn-default" type="button"
          [attr.title]="showPreviewPanel ? 'Hide Preview' : 'Show Preview'" (click)="togglePreview()"
          *ngIf="!hideIcons.TogglePreview">
          <i class="fa" [class.fa-eye]="!showPreviewPanel" [class.fa-eye-slash]="showPreviewPanel"></i>
        </button>
      </div>
      <div class="btn-group pull-right hide-split">
        <button class="btn btn-sm btn-default" type="button" [class.active]="isFullScreen" (click)="fullScreen()"
          *ngIf="!hideIcons.FullScreen">
          <i class="fa" [class.fa-arrows-alt]="!options?.usingFontAwesome5 || !isFullScreen"
            [class.fa-compress]="options?.usingFontAwesome5 && isFullScreen"></i>
        </button>
      </div>
    </div>
    <div class="editor-container">
      <div [class.dragover]="dragover" [style.display]="mode == 'preview' ? 'none' : null"
        (dragover)="onDragover($event)">
        <div class="drag-container">
          <div class="upload-loading">
            <i class="fa fa-upload" *ngIf="!isUploading"></i>
            <i class="fa fa-spinner fa-pulse fa-fw" *ngIf="isUploading"></i>
            <div class="text">{{ isUploading ? 'Uploading' : 'Drag it here' }}</div>
          </div>
        </div>
        <div class="drag-container drag-container-mask" (drop)="onDrop($event)" (dragleave)="onDragleave($event)"></div>
        <div class="editor-panel" contenteditable="true" (paste)="onAceEditorPaste($event)">
          <div class="ace-editor" #aceEditor></div>
        </div>
      </div>
      <div class="preview-container" [style.display]="(mode == 'preview' || showPreviewPanel) ? 'block' : 'none'"
        (click)="previewPanelClick($event)">
        <div class="preview-panel" #previewContainer></div>
      </div>
    </div>
    <div class="md-footer" *ngIf="maxlength > 0 && mode != 'preview'">
      <div class="text-right length-view">
        {{ markdownValue?.length }} / {{ maxlength }}
      </div>
      <div class="resize-btn"></div>
    </div>
  </div>
  <ngx-markdown-editor-resize-sensor *ngIf="options?.resizable" (resize)="mdEditorResize($event)"></ngx-markdown-editor-resize-sensor>
</div>
